module.exports = __webpack_public_path__ + "img/ico-round-phone.3ef0fe0a.svg";